import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { submit as formSubmit, reduxForm, Field } from 'redux-form'
import { Dropdown } from 'semantic-ui-react'
import { fetchSFM, getPending } from 'loankeeper-common/helpers/SimpleFetchManager'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { ComponentContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'

import { ResourceDropdownWrapperProps, ResourceDropdownProps } from '../../types.LoanDetails'
import { AppDispatch } from 'src/store/index.d'
import { updateResourceID } from 'src/store/loan'

const getDropDownOnChange =
  (storeOnChange) =>
  (e, { value }) =>
    storeOnChange(value)

const component = ({ input: { value, onChange }, options }) => (
  <ComponentContainer dropdown style={{ width: 'auto', float: 'left' }}>
    <Dropdown button search selection options={options} value={value} onChange={getDropDownOnChange(onChange)} />
  </ComponentContainer>
)

const formContainer = reduxForm({
  destroyOnUnmount: false,
  onSubmit: ({ resource }, dispatch: AppDispatch, { keyByID, ID, hash }) =>
    new Promise((resolve, reject) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: keyByID,
      //     callApi: Loan.updateResourceID,
      //     callApiArgs: [resource, ID, hash],
      //     resolve,
      //     reject,
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page=resourceupdate
      dispatch(
        updateResourceID({
          LoanID: ID,
          HashSum_LoanID_: hash,
          ResourceID: resource,
        }),
      ).then((response) => {
        if (!updateResourceID.fulfilled.match(response)) {
          reject()
          return
        } else {
          resolve(response.payload)
        }
      })
    }),
})

//@ts-ignore
const ResourceDropdown = formContainer((props: ResourceDropdownProps) => {
  const { handleSubmit, options, form, keyByID } = props
  const dispatch = useDispatch()

  const pending = useSelector((state) => getPending(keyByID)(state))

  // open confirm modal
  function handleClick() {
    dispatch(LKModalActions.openConfirmation('resourceModal'))
  }

  function handleConfirm() {
    dispatch(formSubmit(form))
  }

  return (
    <div>
      <LKModal.Confirmation name="resourceModal" onConfirm={handleConfirm} loading={pending} />

      <form onSubmit={handleSubmit}>
        <Field name="resource" component={component} options={options} />

        <LKButton alias="save" onClick={handleClick} permission="CHANGE_LOAN_RESOURCE" />
      </form>
    </div>
  )
})

const ResourceDropdownWrapper: FC<ResourceDropdownWrapperProps> = (props) => {
  const { ID, initialValue } = props
  const keyByID = `LoanDetailsOther-${ID}-ResourceDropdown`

  return <ResourceDropdown {...props} initialValues={{ resource: initialValue }} form={keyByID} keyByID={keyByID} />
}

export default ResourceDropdownWrapper
